import React, { Component } from 'react'
import {EditorState, ContentState, RichUtils} from 'draft-js'
import {stateToHTML} from 'draft-js-export-html'
import {stateFromHTML} from 'draft-js-import-html'
import EditorUI from './EditorUI'

// https://codepen.io/Kiwka/pen/YNYvyG
class EditorSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: this.props.html ?
        EditorState.createWithContent(stateFromHTML(this.props.html)) :
        EditorState.createEmpty()
    };

    this.onTab = (e) => this._onTab(e);
    this.setDomEditorRef = ref => this.domEditor = ref;

    // this.toggleBlockType = (type) => this._toggleBlockType(type);
    // this.handleKeyCommand = (command) => this._handleKeyCommand(command);
    // this.toggleInlineStyle = (style) => this._toggleInlineStyle(style);
  }

  render() {
    /*
     const {editorState} = this.state;

     // If the user changes block type before entering any text, we can
     // either style the placeholder or hide it. Let's just hide it now.
     let className = 'RichEditor-editor';
     var contentState = editorState.getCurrentContent();
     if (!contentState.hasText()) {
       if (contentState.getBlockMap().first().getType() !== 'unstyled') {
         className += ' RichEditor-hidePlaceholder';
       }
    }
    */

   return (
     <EditorUI
        messageList={this.props.messageList}
        editorState={this.state.editorState}
        toggleBlockType={this.toggleBlockType}
        toggleInlineStyle={this.toggleInlineStyle}
        handleKeyCommand={this.handleKeyCommand}
        handleReturn={this.handleReturn}
        onChange={this.onChange}
        onTab={this.onTab}
        placeholderKey={this.props.placeholderKey}
        setDomEditorRef={this.setDomEditorRef}
     />
    );
  }

  componentDidMount() {
    // https://github.com/facebook/draft-js/blob/master/examples/draft-0-10-0/plaintext/plaintext.html
    if (this.props.autoFocus)
      this.domEditor.focus()
  }

  UNSAFE_componentWillReceiveProps(props) {
    // after create cancel or create complete, html is set to null; need to clear contenteditable
    if (!props.html && this.state.editorState.getCurrentContent().getPlainText().trim().length > 0) {
      let editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));
      this.setState({editorState: editorState})
    }
  }

  onChange = (editorState) => {
    this.setState({editorState})
    if (editorState.getCurrentContent().getPlainText().trim().length > 0) {
      this.props.onChange(stateToHTML(editorState.getCurrentContent()))
    }
    else {
      this.props.onChange('')
    }
  }

  handleKeyCommand = (command) => {
    const editorState = this.state.editorState
    const newState = RichUtils.handleKeyCommand(editorState, command)
    if (newState) {
      this.onChange(newState)
      return true
    }
    return false
  }

  // https://github.com/HubSpot/draft-convert/issues/83
  handleReturn = (e) => {
    const editorState = this.state.editorState
    this.setState({editorState: RichUtils.insertSoftNewline(editorState)})
    return 'handled'
  }

  _onTab(e) {
    const maxDepth = 4;
    this.onChange(RichUtils.onTab(e, this.state.editorState, maxDepth));
  }

  toggleBlockType = (blockType) => {
    this.onChange(RichUtils.toggleBlockType(this.state.editorState, blockType))
  }

  toggleInlineStyle = (inlineStyle) => {
    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, inlineStyle ))
  }
}

export default EditorSF
